import React, {useEffect, useState} from 'react';

import Modal from '../Modal/Modal';
import Button from '../Form/Button/Button';
import VerifyOtp from '../Session/VerifyOtp';

/** @import {OTPModalMoveOnProps, OTPModalProps, OTPModalStepOneProps, OTPModalStepTwoProps} from './OTPModalTypes' */

import './otpModal.scss';

function OTPModalStepOne(/** @type {OTPModalStepOneProps} */ { title, onNext, mobileNumber, verificationToken, customVerification, isResendActivationOtp, analyticsRegion, analyticsAction, noNumberMessage, isSendingOtp, onRetrySend, errorMessage }) {
  if (isSendingOtp) {
    return <>
      <h2 className="modal__title login__title otp-modal__title">{title}</h2>
      <p className="modal__slim" role="status">Sending your one-time passcode...</p>
    </>;
  }

  if (!verificationToken && onRetrySend) {
    return <>
      <h2 className="modal__title login__title otp-modal__title">{title}</h2>
      {errorMessage && <div className="login__error"><span className="login__error--wrap">{errorMessage}</span></div>}
      <Button label="Try again" onClick={onRetrySend} />
    </>;
  }

  const verify = (/** @type {string} */ otp, /** @type {string} */ mode) => {
    return new Promise((resolve, reject) => {
      customVerification(otp, mode).then(r => {
        resolve(r);
          if (r.success === true){
            onNext();
        }
      }).catch(e => {
        reject({success: false, data: {}});
      });
    });
  };

  return (
    <>
      <h2 className="modal__title login__title otp-modal__title">{title}</h2>
      <VerifyOtp 
          verificationToken={verificationToken} 
          mobileNumber={mobileNumber} 
          noNumberMessage={noNumberMessage}
          customVerify={verify} 
          isResendActivationOtp={isResendActivationOtp}
          analyticsRegion={analyticsRegion || "unknown"}
          analyticsAction={analyticsAction || "unknown"}
      />
    </>
  );
};

function OTPModalStepTwo(/** @type {OTPModalStepTwoProps} */ {successMessage, onComplete, customLayout}) {
  return (
    <>
        {customLayout ? customLayout : <>    <h4 className="modal__success-title">Success!</h4>
            <p className="modal__paragraph">{successMessage}</p>
            <div className="modal__spacer"/>
            <Button size='med' label="Done" onClick={onComplete}/>
        </>}
    </>
  );
}

function OTPModalMoveOn(/** @type {OTPModalMoveOnProps} */ {onComplete}) {

    useEffect(()=> {
        onComplete()
    },[])
    return <></>
}

function OTPModal(/** @type {OTPModalProps} */ {
    title, 
    mobileNumber, 
    successMessage, 
    customLayout, 
    customClassName, 
    onClose, 
    onComplete, 
    verificationToken, 
    customVerification, 
    analyticsRegion, 
    analyticsAction, 
    showConfirmationOnSuccess= true,
    isResendActivationOtp = false,
    noNumberMessage = false,
    isSendingOtp = false,
    onRetrySend,
    errorMessage,
    hideClose = false
}) {
  const [step, setStep] = useState(0);
  const onNext = () => setStep(1);

    const onCloseHandler = () => {
        if (step === 0 && onClose) onClose();
        else if (onComplete) onComplete();
    };
    
  return (
    <Modal onClose={onCloseHandler} className={customClassName? customClassName: "modal--fixed-height"} ignoreClickOutside={true} hideClose={hideClose}>
      {step === 0 &&
        <OTPModalStepOne title={title} mobileNumber={mobileNumber} onNext={onNext} verificationToken={verificationToken} customVerification={customVerification} isResendActivationOtp={isResendActivationOtp} analyticsAction={analyticsAction} analyticsRegion={analyticsRegion} noNumberMessage={noNumberMessage} isSendingOtp={isSendingOtp} onRetrySend={onRetrySend} errorMessage={errorMessage} />}
        {step !== 0 && showConfirmationOnSuccess &&
        <OTPModalStepTwo successMessage={successMessage} onComplete={onComplete} customLayout={customLayout} />
      }
        {step !== 0 && !showConfirmationOnSuccess && <OTPModalMoveOn onComplete={onComplete}/>}
    </Modal>
  );
};

export default OTPModal;
